import React from 'react';
import { connect } from 'react-redux';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import Content from '../../../layout/Content';
import ManifestLegalAbandonmentForm from './ManifestLegalAbandonmentForm';

export const ManifestLegalAbandonment = ({ breadcrumbs }) => (
  <Content
    breadcrumbs={breadcrumbs}
    title="Manifestar Abandono Legal"
    subtitle="Manifestar abandono legal"
    content={<ManifestLegalAbandonmentForm />}
  />
);

ManifestLegalAbandonment.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
};

const mapStateToProps = ({ CargoUnit }) => ({
  breadcrumbs: [
    ...CargoUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Arribar Abandono Legal',
      href: '',
    },
  ],
});

export default connect(mapStateToProps)(ManifestLegalAbandonment);
